import classNames from "classnames";

function SideIcon({ iconSide }) {
  if (!iconSide) {
    return null;
  }
  return (
    <i
      className={classNames({
        "las la-angle-right float-right mt-1": iconSide === "right",
        "las la-angle-right float-left mt-1 pe-2": iconSide === "left",
      })}
    />
  );
}
export default SideIcon;
